import React from "react";

const Close = ({...htmlAttributes}) => (
  <svg {...htmlAttributes} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <g transform="translate(-370.207 -119.914)">
      <path d="M377.627,125.915l4.286-4.287a1,1,0,0,0-1.42-1.42l-4.286,4.286-4.287-4.285a1,1,0,0,0-1.419,1.419l4.286,4.286L370.5,130.2a1,1,0,1,0,1.419,1.421h0l4.286-4.286,4.286,4.286a1,1,0,0,0,1.42-1.42Z"/>
      <rect width="12" height="12" transform="translate(370.207 119.914)"/>
    </g>
  </svg>
);

export default Close;
